import React, { useState, useEffect } from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import AnalyticsDashboard from './AnalyticsDashboard'
import { Link } from 'react-router-dom'

function UserHome() {
  const rolename = localStorage.getItem('role')
  const [parentCount, setParentCount] = useState(0)
  const [studentCount, setStudentCount] = useState(0)
  const [actCount, setActCount] = useState(0)
  const [satCount, setSatCount] = useState(0)
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}getallcounts`)
      .then((response) => response.json())
      .then((data) => {
        setParentCount(data.parents_count)
        setStudentCount(data.students_count)
        setActCount(data.act_count)
        setSatCount(data.sat_count)
      })
      .catch((error) => {
        console.error('Error fetching student count:', error)
      })
  }, [])
  const currentDate = new Date()
  const formattedDate = currentDate.toDateString()
  if (rolename === 'admin' || rolename === 'subadmin') {
    return (
      <div
        style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}
      >
        <Leftbar />
        <div
          style={{
            flex: 1,
            minHeight: '100vh',
            marginLeft: '20px',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: 0,
            boxSizing: 'border-box',
          }}
        >
          <SHeaderbar />
          <div style={{ flex: 1, padding: 0, minHeight: 0 }}>
            <div style={{ margin: '32px 0' }}>
              <div style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
                <div
                  style={{
                    flex: 1,
                    background: '#fff',
                    border: '2px solid #DE3C7D',
                    borderRadius: 16,
                    padding: '28px 0',
                    boxShadow: '0 2px 8px 0 rgba(222,60,125,0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'box-shadow 0.2s',
                  }}
                >
                  <span
                    style={{
                      color: '#030303',
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 8,
                    }}
                  >
                    Parents
                  </span>
                  <span
                    style={{ color: '#DE3C7D', fontWeight: 700, fontSize: 36 }}
                  >
                    {parentCount}
                  </span>
                </div>
                <div
                  style={{
                    flex: 1,
                    background: '#fff',
                    border: '2px solid #DE3C7D',
                    borderRadius: 16,
                    padding: '28px 0',
                    boxShadow: '0 2px 8px 0 rgba(222,60,125,0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'box-shadow 0.2s',
                  }}
                >
                  <span
                    style={{
                      color: '#030303',
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 8,
                    }}
                  >
                    Students
                  </span>
                  <span
                    style={{ color: '#DE3C7D', fontWeight: 700, fontSize: 36 }}
                  >
                    {studentCount}
                  </span>
                </div>
                <div
                  style={{
                    flex: 1,
                    background: '#fff',
                    border: '2px solid #DE3C7D',
                    borderRadius: 16,
                    padding: '28px 0',
                    boxShadow: '0 2px 8px 0 rgba(222,60,125,0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'box-shadow 0.2s',
                  }}
                >
                  <span
                    style={{
                      color: '#030303',
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 8,
                    }}
                  >
                    ACT Tests
                  </span>
                  <span
                    style={{ color: '#DE3C7D', fontWeight: 700, fontSize: 36 }}
                  >
                    {actCount}
                  </span>
                </div>
                <div
                  style={{
                    flex: 1,
                    background: '#fff',
                    border: '2px solid #DE3C7D',
                    borderRadius: 16,
                    padding: '28px 0',
                    boxShadow: '0 2px 8px 0 rgba(222,60,125,0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    transition: 'box-shadow 0.2s',
                  }}
                >
                  <span
                    style={{
                      color: '#030303',
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 8,
                    }}
                  >
                    SAT Tests
                  </span>
                  <span
                    style={{ color: '#DE3C7D', fontWeight: 700, fontSize: 36 }}
                  >
                    {satCount}
                  </span>
                </div>
              </div>
            </div>
            <AnalyticsDashboard />
            <SFooterbar />
          </div>
        </div>
      </div>
    )
  }
}

export default UserHome
